import { useRef } from 'react'
import * as VKID from '@vkid/sdk'
import { useMount } from '../../shared/lib/utils.ts'

export interface VKIDAuthData {
  code: string
  state: string
  device_id?: string
}

export interface VKIDCallbackData {
  type: string
  code: string
  state: string
}

export interface VKIDLoginSuccessPayload {
  code: string
  device_id?: string
  state?: string
}

export interface VKAuthButtonProps {
  onAuthCallback: (token: string) => void
  onError?: (error: string) => void
  width?: number
  className?: string
}

const VKID_CLIENT_ID = import.meta.env.VITE_VKID_CLIENT_ID
const VKID_REDIRECT_URI = import.meta.env.VITE_VKID_REDIRECT_URI

const exchangeCode = async (code: string, deviceId: string) => {
  const { id_token } = (await VKID.Auth.exchangeCode(
    code,
    deviceId,
  )) as VKID.TokenResult
  return id_token
}

export function VKIDAuthButton(props: VKAuthButtonProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const width = props.width ?? 400

  useMount(() => {
    const currentRef = containerRef.current
    VKID.Config.init({
      app: VKID_CLIENT_ID,
      redirectUrl: VKID_REDIRECT_URI,
      responseMode: VKID.ConfigResponseMode.Callback,
    })

    if (currentRef) {
      currentRef.innerHTML = ''

      try {
        const oneTap = new VKID.OneTap()

        oneTap.on(
          VKID.OneTapInternalEvents.LOGIN_SUCCESS,
          async (payload: VKIDLoginSuccessPayload) => {
            if (payload.device_id) {
              const token = await exchangeCode(payload.code, payload.device_id)
              props.onAuthCallback(token)
            } else {
              props.onError?.('No device_id')
            }
          },
        )

        oneTap.render({
          container: containerRef.current,
          lang: VKID.Languages.RUS,
          skin: VKID.OneTapSkin.Primary,
          contentId: VKID.OneTapContentId.OPEN,
          styles: {
            width,
            height: 48,
            borderRadius: 24,
          },
        })
      } catch (error) {
        console.error('Error initializing VK ID button:', error)
      }
    }
  })

  return <div ref={containerRef} className={props.className} />
}
